// Trix weighs ~66 KiB and only the rich text editors need it, so it is fetched
// the first time an editor appears instead of riding in the pack every page
// loads. Our attribute config comes with it so every editor, kit or legacy,
// parses the same HTML marks.
let loading;

function configure(Trix) {
  if (!Trix.config.textAttributes.underline) {
    Trix.config.textAttributes.underline = { tagName: 'u', inheritable: true };
  }

  ['heading2', 'heading3', 'heading4'].forEach((name, index) => {
    if (!Trix.config.blockAttributes[name]) {
      Trix.config.blockAttributes[name] = {
        tagName: `h${index + 2}`,
        terminal: true,
        breakOnReturn: true,
        group: false,
      };
    }
  });

  return Trix;
}

export default function loadTrix() {
  if (!loading) {
    loading = Promise.all([import('trix'), import('trix/dist/trix.css')]).then(
      ([mod]) => configure(mod.default || mod)
    );
  }

  return loading;
}
